export const PYTHON_ACTIONS = [
  {
    custom: true,
    icon: 'curly-brackets',
    action: 'py-beautify',
    tooltip: 'format code',
    color: 'primary',
    aria: 'format code',
    testId: 'format-code'
  },
]
